// Buttons opted into the native-share enhancement carry this attribute.
export const SHARE_SELECTOR = '[data-video-share]';
// Applied to the clicked button while the mp4 is being fetched for the share sheet.
export const BUSY_CLASS = 'is-sharing';
// Holds the "42%" / "…" label shown over a busy button (see generation.styl ::before).
export const PROGRESS_ATTR = 'data-share-progress';
export const MIME_MP4 = 'video/mp4';
export const FALLBACK_FILENAME = 'video.mp4';
